import React from 'react';
import { __ } from "@wordpress/i18n";

const Sidebar = ({ items, onSelectItem, selectedItemId }) => {
  const handleSelectItem = (item) => {
    onSelectItem(item); // Trigger onSelectItem callback passed from parent
  };

  return (
    <div style={{ padding: "1rem", width: "100%" }}>
      {/* Loop through items to render main title, icon, and title */}
      {items.map((item) => (
        <div key={item.id} className="mb-2">
          {item.main && (
            <p className="text-sm text-text-tertiary font-normal mb-2">
              {__(item.main, 'uael')}
            </p>
          )}

          {/* Each item with icon and title */}
          <div
            className={`h-10 flex items-center justify-start gap-2 px-2 rounded-md cursor-pointer ${selectedItemId === item.id ? 'bg-gray-100' : 'bg-background-primary'}`}
            style={{
              backgroundColor: selectedItemId === item.id ? '#F9FAFB' : '', // Apply background color when selected
            }}
            onClick={() => handleSelectItem(item)}
          >
            <span>
              {selectedItemId === item.id ? item.selected : item.icon}
            </span>
            <p className="m-0 text-base font-normal">{__(item.title, 'uael')}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Sidebar;
